<template>
  <div class="integral_userList b_white">
    <div class="user_search">
      <van-search v-model="phoneOrName" placeholder="请输入姓名或手机号" />
      <span @click="getPointsMemberList(true)">搜索</span>
    </div>
    <div class="box60"></div>
    <van-list
      :loading="loading"
      :finished="finished"
      :offset="20"
      :immediate-check="false"
      finished-text=""
      @load="onLoad"
    >
      <ul>
        <li v-for="item in allRecordList" :key="item.id">
          <router-link :to="`/integral/gift?shopId=${shopId}&giveType=${giveType}&realName=${item.realName}&mobilePhone=${item.mobilePhone}&boId=${item.boids}`">
            <p class="gray_3">{{item.realName}}</p>
            <p class="gray_9 f12_rem mar5_t">{{item.mobilePhone}}</p>
          </router-link>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>

import { mapState } from "vuex";
import { Toast } from "vant";
import common from "@/assets/js/common";

export default {
  data() {
    return {
      shopId: "",
      giveType: "",
      finished: false,
      loading: false,
      allRecordList: [],
      pageNum: 1,
      pageSize: 32767,
      phoneOrName: ""
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    if (!common.isLogin(this.userInfo.id)) {
      return;
    }
    this.giveType = this.$route.query.giveType;
    this.shopId = this.$route.query.shopId;
    this.getPointsMemberList(true);
  },
  methods: {
    onLoad() {
      this.loading = true;
      this.clickToMore();
    },
    // 加载更多
    clickToMore() {
      this.pageNum = this.pageNum + 1;
      this.getPointsMemberList(false);
    },
    getPointsMemberList(load) {
      if (load === true) {
        this.allRecordList = [];
        this.pageNum = 1;
        this.finished = false;
        Toast.loading({
          mask: true,
          message: "加载中...",
          duration: 0
        });
      }
      const params = {
        searchField: this.phoneOrName,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$store.dispatch("member/member/getPointsMemberList", this.$qs.stringify(params)).then((data) => {
        Toast.clear();
        const list = data || {};
        // 加载状态结束
        this.loading = false;
        // 加载更多
        this.allRecordList = [...this.allRecordList, ...list];
        if (list.length === 0) {
          this.finished = true;
        }
      }).catch(() => {
        Toast.clear();
      });
    }
  }
};
</script>


<style lang="scss" scoped>
  @import './style.scss';
</style>
